import apiService from './ApiService';

class AdminDashboardService {
  async getDashboard(colegioId) {
    if (!colegioId) {
      throw new Error('No hay colegio seleccionado para cargar el dashboard.');
    }

    const response = await apiService.get(`/admindashboard/${colegioId}`);

    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos cargar el dashboard.';
      throw new Error(msg);
    }

    return response;
  }
}

const adminDashboardService = new AdminDashboardService();

export default adminDashboardService;
